module.exports = __webpack_public_path__ + "static/award2-f099b6e1b88a4ec53470a64161cffe4d.png";